import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/manga';

export default function LatestUpdates() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6 md:mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            最新更新
          </h2>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse ml-1"></span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {latestUpdates.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-0 left-0 right-0 p-2 bg-gradient-to-b from-black/40 to-transparent">
                  <span className="text-xs text-white/90">
                    {manga.tags.slice(0, 2).join(' · ')}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-white/90 text-xs">
                    <i className="ri-time-line"></i>
                    <span>刚刚更新</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors truncate">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.updateChapter}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}